<template>
  <div class="programme">
    <div class="header">
      <div class="title">行业解决方案</div>
      <div class="border"></div>
    </div>
    <div class="hardware-list">
      <div class="list">
        <div class="item" v-for="item in hardwareList" :key="item.id">
          <div class="box">
            <div class="right">
              <div class="flex">
                <div class="title">{{ item.title }}</div>
                <router-link :to="item.path">
                  <div class="more">了解更多 ></div>
                </router-link>
              </div>
              <div class="text">{{ item.text }}</div>
              <div class="right-list">
                <div
                  class="right-item"
                  v-for="it in item.rightList"
                  :key="it.id"
                >
                  <img class="logo" :src="it.logo" alt="" />
                  <div class="item-title">{{ it.title }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import yesLogo from "../../../assets/programme/yesLogo.png";

export default {
  setup() {
    return reactive({
      hardwareList: [
        {
          id: 1,
          title: "智慧社区",
          text: "全面的物业管理功能+IOT硬件对接率",
          path: "/mobile/programme/community",
          rightList: [
            {
              id: 1,
              title: "物业基础数字化",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "财务管理智能化",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "业主生活便利化",
              logo: yesLogo,
            },
            {
              id: 4,
              title: "社区生活智能化",
              logo: yesLogo,
            },
            {
              id: 5,
              title: "移动办公效率化",
              logo: yesLogo,
            },
            {
              id: 6,
              title: "社区流量商业变现",
              logo: yesLogo,
            },
          ],
        },
        {
          id: 2,
          title: "智慧物业",
          text: "聚焦物业管理，打造软硬一体化的物业管理",
          path: "/mobile/programme/property",
          rightList: [
            {
              id: 1,
              title: "统一管理",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "员工管理",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "智能安防",
              logo: yesLogo,
            },
            {
              id: 4,
              title: "设备管理",
              logo: yesLogo,
            },
            {
              id: 5,
              title: "智能门禁",
              logo: yesLogo,
            },
            {
              id: 6,
              title: "在线报修",
              logo: yesLogo,
            },
          ],
        },
        {
          id: 3,
          title: "智慧后勤",
          text: "聚焦后勤管理场景，构建一体化管理平台",
          // path: "/mobile/programme/logistics",
          path: '',
          rightList: [
            {
              id: 1,
              title: "资产物料数字化",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "车辆管理智能化",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "物业管理线上化",
              logo: yesLogo,
            },
            {
              id: 4,
              title: "安保管理全面化",
              logo: yesLogo,
            },
            {
              id: 5,
              title: "办公管理效率化",
              logo: yesLogo,
            },
            {
              id: 6,
              title: "移动办公快速化",
              logo: yesLogo,
            },
          ],
        },
        {
          id: 4,
          title: "社区管理",
          text: "多种AI算法，轻松搞定社区管理工作",
          path: "/mobile/programme/communityadmin",
          rightList: [
            {
              id: 1,
              title: "垃圾治理",
              logo: yesLogo,
            },
            {
              id: 2,
              title: "社区安全治理",
              logo: yesLogo,
            },
            {
              id: 3,
              title: "出入人员治理",
              logo: yesLogo,
            },
            {
              id: 4,
              title: "停车治理",
              logo: yesLogo,
            },
            {
              id: 5,
              title: "危险行为警告",
              logo: yesLogo,
            },
            {
              id: 6,
              title: "重点人员监控",
              logo: yesLogo,
            },
          ],
        },
      ],
    });
  },
};
</script>

<style scoped>
.programme {
  width: 100%;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.hardware-list {
  margin-top: 16px;
}
.hardware-list .list .item {
  background: linear-gradient(180deg, #eff7ff 0%, #fdfeff 100%);
  box-shadow: inset 0px 10px 20px 1px rgba(31, 81, 210, 0.06);
}
.hardware-list .list .item .box {
  padding: 12px;
}
.hardware-list .list .item .box .right .flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.hardware-list .list .item .box .right .title {
  font-size: 14px;
  color: #2a3d50;
   font-weight: 600;
}
.hardware-list .list .item .box .right .more {
  font-size: 14px;
  color: #248efb;
}
.hardware-list .list .item .box .right .text {
  margin-top: 13px;
  font-size: 13px;
  color: #4c6681;
}
.hardware-list .list .item .box .right .right-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.hardware-list .list .item .box .right .right-list .right-item {
  width: 115px;
  display: flex;
  align-items: center;
  margin-top: 18px;
}
.hardware-list .list .item .box .right .right-list .right-item .logo {
  width: 10px;
  margin-right: 8px;
}
.hardware-list .list .item .box .right .right-list .right-item .item-title {
  font-size: 12px;
  color: #2a3d50;
}
</style>
